import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 6h10","key":"svg-0"}],["path",{"d":"M4 12h16","key":"svg-1"}],["path",{"d":"M7 12h13","key":"svg-2"}],["path",{"d":"M7 18h10","key":"svg-3"}]]

/**
 * IconMenu4
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItbWVudS00Igo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik03IDZoMTAiIC8+CiAgPHBhdGggZD0iTTQgMTJoMTYiIC8+CiAgPHBhdGggZD0iTTcgMTJoMTMiIC8+CiAgPHBhdGggZD0iTTcgMThoMTAiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/menu-4
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconMenu4 = createReactComponent('outline', 'menu-4', 'Menu4', __iconNode);

export default IconMenu4;